// Always lbs, oz and drms (e.g. "6 lbs 0 oz 0 drms"), unlike formatLbs which drops zero parts.
function formatKgLbsOzDrms(kg) {
  const totalDrms = Math.round(kg * 2.20462 * 256);
  const lbs = Math.floor(totalDrms / 256);
  const oz = Math.floor((totalDrms % 256) / 16);
  const drms = totalDrms % 16;
  return `${lbs} lbs ${oz} oz ${drms} drms`;
}

function FishRow({ label, fish }) {
  if (!fish) {
    return (
      <div className="rounded-lg border border-dashed border-white/15 px-3 py-2 text-sm text-slate-500">
        No {label} yet
      </div>
    );
  }
  return (
    <div className="rounded-lg border border-white/10 bg-slate-950/50 px-3 py-2 text-sm">
      <div className="flex items-center justify-between">
        <span className="text-slate-200 truncate">{fish.species}</span>
        <span className={`shrink-0 ml-2 font-semibold ${fish.pct >= 100 ? "text-yellow-400" : "text-emerald-400"}`}>
          {fish.pct.toFixed(1)}%
        </span>
      </div>
      <p className="mt-0.5 text-xs text-slate-400">{formatKgLbsOzDrms(fish.weight_kg)}</p>
    </div>
  );
}

// Card grid in the same style as the August Bream Competition leaderboard.
export default function RayBassLeaderboard({ entries }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {entries.map((entry) => (
        <div key={entry.angler} className="rounded-lg border border-white/10 bg-white/5 p-4 hover:bg-white/10 transition panel-lift">
          <div className="flex items-center justify-between mb-3">
            <div>
              <p className="text-sm text-slate-400">#{entry.rank}</p>
              <p className="text-lg font-semibold text-emerald-300">{entry.angler}</p>
            </div>
            <span className="text-xs text-slate-400">Total: <span className="text-white font-semibold">{entry.total.toFixed(1)}%</span></span>
          </div>
          <div className="space-y-2">
            <FishRow label="ray" fish={entry.ray} />
            <FishRow label="bass" fish={entry.bass} />
          </div>
        </div>
      ))}
    </div>
  );
}
